import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class AlphanumericCounter {
    private currentBaseCharsCount: number = 0;
    private currentAlphanumericCharsCount: number = 0;
    private readonly baseChars: string = '0123456789';
    private readonly alphanumericChars: string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';


    getNextId(alphanumeric:boolean = false): string {
        const result = this.generateUniqueId(alphanumeric);
        alphanumeric ? this.currentAlphanumericCharsCount++ : this.currentBaseCharsCount++;
        return result;
    }

    private generateUniqueId(alphanumeric:boolean): string {
        const baseCharsLength = alphanumeric ? this.alphanumericChars.length : this.baseChars.length;
        const charsData = alphanumeric ? this.alphanumericChars : this.baseChars;
        let result = '';
        let count = alphanumeric ? this.currentAlphanumericCharsCount : this.currentBaseCharsCount;
        do {
            result = charsData.charAt(count % baseCharsLength) + result;
            count = Math.floor(count / baseCharsLength);
        } while (count > 0);

        return result;
    }
    
    getCurrentId(alphanumeric:boolean = false):string {
        return this.generateUniqueId(alphanumeric);
    }
}


